import { useState, useCallback } from 'react';

// Services

import OptionsService from '../services/options.service';

export default function GetMunicipalitiesByState() {
    const [getMunicipalitiesIsLoading, setGetMunicipalitiesIsLoading] = useState(false);
    const [getMunicipalitiesError, setGetMunicipalitiesError] = useState(null);
    const [municipalities, setMunicipalities] = useState([]);

    // Get the Municipalities by State

    const handleGetMunicipalitiesByState = useCallback(async (state) => {
        setGetMunicipalitiesIsLoading(true);
        setGetMunicipalitiesError(null);

        try {

            const municipalitiesRequest = await OptionsService.getMunicipalitiesByState(state);

            setGetMunicipalitiesIsLoading(false);
            setMunicipalities(municipalitiesRequest?.data?.data);
    

        } catch(error) {

            setGetMunicipalitiesIsLoading(false);
            setGetMunicipalitiesError(error.response?.data?.message || error.message);

        }
    }, []);

    return {
        getMunicipalitiesIsLoading,
        getMunicipalitiesError,
        municipalities,
        handleGetMunicipalitiesByState,
        setMunicipalities,
    }
}
